/*
 * @Descripttion: 客户管理创建渠道box组件
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import { Button } from '@alifd/next';
import React from 'react';
import Style from './index.module.scss';
import { useHistory } from 'react-router-dom';
import { store } from '@ice/stark-data';

export default (props) => {
  const history = useHistory();
  // const [labelNum, setLabelNum] = useState(1);
  const goto = () => {
    if (props.title == '官方标签组合') {
      history.push('/crowd/tag/create');
    } else if (props.title == '云鹿标签组合') {
      history.push('/yunLu/crowd/tag/create');
    }  else if (props.title == '用户手机号上传') {
      history.push('/crowd/upload');
    }else if (props.title == '官方标签组合（新）') {
      history.push('/crowd/newtag/create');
    }else if (props.title == '手动上传人群包') {
      history.push('/crowd/phoneUpload/create');
    }

    else {
      const Params = { searchString: '', telList: [], orderCrowdType: '', marketingType: '', marketingTypeText: '' };
      Params.marketingType = '2'; // "营销类型 1-人群营销 2-订单筛选营销",
      Params.marketingTypeText = '订单筛选营销'; // "营销类型 1-人群营销 2-订单筛选营销",
      // 将参数传递至仓库与缓存，若用户刷新页面时仓库数据被清空则使用缓存数据
      store.set('sceneMarketingParams', Params);
      localStorage.setItem('sceneMarketingParams', JSON.stringify(Params));

      // 页面跳转订单筛选页面
      store.set('currentTab', 'orderSelection');
      store.set('currentTab_child', 'childTabs_orderSelect');
      history.push('/orderSelection');
    }
  };
  // useEffect(() => {
  //   if (props.show) {
  //     getNum();
  //   }
  // }, []);

  // const getNum = () => {
  //   Servlets('getLabelNum').then((res) => {
  //     setLabelNum(res.data[0]);
  //   });
  // };
  return (
    // 动态样式
    <div className={Style.container} style={{ border: `2px solid ${props.color}` }}>
      <div
        className={Style.top}
        style={{ background: `${props.color}`, display: 'flex', justifyContent: 'space-evenly' }}
      >
        <div
          style={{ width: '20%', border: `1px solid ${props.color}`, textAlign: 'center' }}
          className={Style.topleft}
        >
          <span className={`iconfont icon-icon-02 ${Style.icon}`} />
        </div>
        <div style={{ width: '80%' }} className={Style.topright}>
          <div className={Style.topright_top}>
            {props.title}
          </div>
          <div className={Style.topright_bottom}>
            {props.content}
          </div>
        </div>
      </div>
      <div className={Style.bottom} style={{ display: 'flex', alignItems: 'center' }}>
        {/* <div style={{ flex: '1', paddingLeft: '30px' }}>
          {props.show &&
          <div>
            <span
              className={'iconfont icon-icon5_huaban1'}
              style={{ fontSize: '12px', color: '#FF3333' }}
            /><span style={{ marginLeft: '5px' }}>
              <span style={{ color: '#FF3333', marginLeft: '10px', textAlign: 'left' }}>{labelNum}</span>个标签可用
            </span>
          </div>
          }
        </div> */}
        <div style={{ flex: '1', textAlign: 'right' }}>
          <Button type="primary" className={Style.btn} onClick={goto}>去创建</Button>
        </div>
      </div>
    </div>
  );
};

